import React from "react";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectBaseDataSet, setBaseDetails } from "../../../features/layers/baselayerslice";
import { setAppDetails } from "../../../features/layers/appslice";
import { setTools } from "../../../features/tools/toolsSlice";
import { setMapBounds, selectMapZoomstate } from "../../../features/maps/mapZoomSlice";
import classes from "./ToolsPanel.module.css"
import aoi from "../../../pic/aoi.png"
import measure from "../../../pic/measure.png"
import printer from "../../../pic/printer.png"
import filter from "../../../pic/filter.png"
import axios from 'axios';
import { selectMapZABstate } from "../../../features/maps/mapZoomandBounds";
import ModalComponent from "../../modals/ModalComponent";
import { selectLayerDataSet } from "../../../features/layers/overlaylayerslice";
import { center } from "@turf/turf";
const AppsPanel = () => {
  const dispatch = useDispatch();
  const state = useSelector(selectMapZoomstate);
  const zab = useSelector(selectMapZABstate);
  const [tools, setTools1] = useState([
    {
      name: "Search",
      show: false,
    },
    {
      name: "Proximity",
      show: false,
    },
    {
      name: "Measure",
      show: false,
    },
    {
      name: "Filter",
      show: false,
    }
  ]);
  const [isLoading, setLoading] = useState(true);
  const [downloadUrl, setDownloadUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false); // State to manage modal open/close
  const baseLayers = useSelector(selectLayerDataSet);
  const ChangeMap = (id) => {
    setTools1([
      tools.filter((e) => (e.name == id ? (e.show = true) : (e.show = false))),
      ...tools,
    ]);
    dispatch(setTools({ name: id }));
    if (id === 'Aoi' || id === 'Measure' || id === 'Proximity') {
      dispatch(setMapBounds({ ...state, sidebutton: false }));
    }
  };
  const handleOpenModal = () => {
    setIsModalOpen(true); 
  };
  const handleCloseModal = () => {
    setIsModalOpen(false); 
  };
  const handleSubmit = (formData) => {
    console.log(formData);
    handleCloseModal(); 
    //printMaps(formData)
  };
  return (
        <React.Fragment>
          <div className={classes.center}>
           <div className={classes.centerchild} onClick={() => ChangeMap("Proximity")}>
            <div title="Filter based on AOI" id="toopltipp" placement="right">
              <img src={aoi} />
            </div>
          </div> 
          {/* <div className={classes.centerchild} onClick={() => ChangeMap("Filter")}>
            <div title="Filter based on Dropdown" id="toopltipp" placement="right">
              <img src={filter} />
            </div>
          </div> */}
          <div className={classes.centerchild} onClick={() => ChangeMap("Measure")}>
            <div title="Measurement Tool" id="toopltipp" placement="right">
            <img src={measure} />
            </div>
          </div>
          {/* <div className={classes.centerchild} onClick={() =>handleOpenModal()}>
            <div title="Measurement Tool" id="toopltipp" placement="right">
            <img src={printer} />
            </div>
          </div> */}
          {isModalOpen && (
            <ModalComponent onClose={handleCloseModal} onSubmit={handleSubmit} />
          )}
          </div>
        </React.Fragment>
  );
};
export default AppsPanel;

